type Props = {
  className?: string;
};

export function TelegramIcon({ className }: Props) {
  return (
    <svg
      className={className}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8008 0C19.8698 0.000216668 25.6005 5.73081 25.6006 12.7998C25.6006 19.8689 19.8698 25.5994 12.8008 25.5996C5.73154 25.5996 0 19.869 0 12.7998C0.000126372 5.73067 5.73162 0 12.8008 0ZM18.0234 7.69531C17.5438 7.70597 16.7971 7.96095 13.248 9.44238C12.0011 9.96463 9.51803 11.0413 5.78809 12.6611C5.19125 12.9063 4.87182 13.1415 4.83984 13.376C4.78694 13.8233 5.4256 13.9621 6.22461 14.2178C6.88531 14.4309 7.75944 14.6758 8.21777 14.6865C8.63343 14.6972 9.09194 14.5265 9.60352 14.1748C13.0867 11.8207 14.8772 10.627 14.9961 10.6045C15.0814 10.5832 15.1881 10.562 15.2627 10.626C15.3371 10.6898 15.3377 10.8173 15.3271 10.8496C15.2632 11.1161 11.9907 14.1001 11.7988 14.292C11.0741 15.038 10.2534 15.4969 11.5215 16.3281C12.6192 17.0528 13.2483 17.5108 14.3779 18.2461C15.092 18.715 15.6573 19.269 16.4033 19.2051C16.7443 19.173 17.0962 18.8535 17.2773 17.8945C17.7036 15.6353 18.5346 10.7225 18.7266 8.69727C18.7479 8.52693 18.7264 8.30301 18.7051 8.19629C18.6838 8.08972 18.6523 7.95033 18.5244 7.84375C18.3647 7.71599 18.1302 7.69536 18.0234 7.69531Z"
        fill="currentColor"
      />
    </svg>
  );
}
